<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-calendar-dots'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [costDifference]="0"
  [totalCost]="0"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [dropdownEnabled]="false"
  [isUptrendPositive]="false"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [isImageIcon]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
></app-kpi-widget>